const baseURL = process.env.REACT_APP_BASE_URL;

export function getAuthToken() {
    return localStorage.getItem("token") || "";
}

// API call to fetch suggestions
export async function fetchPartySuggestions(text, tag, signal) {
    const axios = (await import("axios")).default;
    const body = {
        search_text: text,
        search_type: tag === "Any" ? "both" : tag.toLowerCase()
    };

    const response = await axios.post(
        `${baseURL}/quick-search/suggest-party-names?size=50`,
        body,
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getAuthToken()}`
            },
            signal
        }
    );

    return response.data;
}